export default "__VITE_ASSET__Bu_Mmd07__"